/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAttributeFilter } from '../models/CustomerAttributeFilter';
import type { MetricsApplicantsResponse } from '../models/MetricsApplicantsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MetricsApplicantsService {

    /**
     * Get new applicants count and URL
     * Returns count and universal applicant view URL for new applicants
     * @param xAccessToken
     * @param teamTasks
     * @param openingIds
     * @param locationIds
     * @param brandIds
     * @param positionIds
     * @param openingAttributes Filter applicants by customer attributes attached to the funnel itself. Encoded as opening_attributes[][attribute_key]=K&opening_attributes[][attribute_values][]=v.
     * @param positionAttributes Filter applicants by customer attributes attached to the funnel's position.
     * @param locationAttributes Filter applicants by customer attributes attached to the funnel's location.
     * @returns MetricsApplicantsResponse OK
     * @throws ApiError
     */
    public static getInternalApiWxMetricsApplicantsNew(
        xAccessToken: string,
        teamTasks?: boolean,
        openingIds?: Array<string>,
        locationIds?: Array<string>,
        brandIds?: Array<string>,
        positionIds?: Array<string>,
        openingAttributes?: Array<CustomerAttributeFilter>,
        positionAttributes?: Array<CustomerAttributeFilter>,
        locationAttributes?: Array<CustomerAttributeFilter>,
    ): CancelablePromise<MetricsApplicantsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/metrics/applicants/new',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'team_tasks': teamTasks,
                'opening_ids[]': openingIds,
                'location_ids[]': locationIds,
                'brand_ids[]': brandIds,
                'position_ids[]': positionIds,
                'opening_attributes[]': openingAttributes,
                'position_attributes[]': positionAttributes,
                'location_attributes[]': locationAttributes,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get pipeline applicants count and URL
     * Returns count and universal applicant view URL for pipeline applicants
     * @param xAccessToken
     * @param teamTasks
     * @param openingIds
     * @param locationIds
     * @param brandIds
     * @param positionIds
     * @param openingAttributes Filter applicants by customer attributes attached to the funnel itself. Encoded as opening_attributes[][attribute_key]=K&opening_attributes[][attribute_values][]=v.
     * @param positionAttributes Filter applicants by customer attributes attached to the funnel's position.
     * @param locationAttributes Filter applicants by customer attributes attached to the funnel's location.
     * @returns MetricsApplicantsResponse OK
     * @throws ApiError
     */
    public static getInternalApiWxMetricsApplicantsPipeline(
        xAccessToken: string,
        teamTasks?: boolean,
        openingIds?: Array<string>,
        locationIds?: Array<string>,
        brandIds?: Array<string>,
        positionIds?: Array<string>,
        openingAttributes?: Array<CustomerAttributeFilter>,
        positionAttributes?: Array<CustomerAttributeFilter>,
        locationAttributes?: Array<CustomerAttributeFilter>,
    ): CancelablePromise<MetricsApplicantsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/metrics/applicants/pipeline',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'team_tasks': teamTasks,
                'opening_ids[]': openingIds,
                'location_ids[]': locationIds,
                'brand_ids[]': brandIds,
                'position_ids[]': positionIds,
                'opening_attributes[]': openingAttributes,
                'position_attributes[]': positionAttributes,
                'location_attributes[]': locationAttributes,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}